import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=9ab7e2e2"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuItems: require('/opt/build/repo/components/menu/Items.vue').default,MenuCategoryItems: require('/opt/build/repo/components/menu/category/Items.vue').default})
